import { Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PillTabs, type PillTabOption } from "@/components/ui/pill-tabs";
import { FilterBar, FilterSearch } from "@/components/ui/filter-bar";
import type { Category } from "@/types";

interface EventFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
  categoryId: string;
  onCategoryChange: (value: string) => void;
  categories: Category[];
  hidePast?: boolean;
  onHidePastChange?: (value: boolean) => void;
  includeDraftStatus?: boolean;
}

export function EventFilters({
  search,
  onSearchChange,
  status,
  onStatusChange,
  categoryId,
  onCategoryChange,
  categories,
  hidePast,
  onHidePastChange,
  includeDraftStatus,
}: EventFiltersProps) {
  const statusOptions: PillTabOption[] = [
    { value: "all", label: "Wszystkie" },
    ...(includeDraftStatus ? [{ value: "draft", label: "Szkice" }] : []),
    { value: "pending", label: "Oczekujące" },
    { value: "approved", label: "Zatwierdzone" },
    { value: "rejected", label: "Odrzucone" },
  ];

  return (
    <FilterBar>
      <PillTabs value={status} onChange={onStatusChange} options={statusOptions} />
      <FilterSearch
        value={search}
        onChange={onSearchChange}
        debounceMs={300}
        placeholder="Szukaj wydarzeń..."
      />
      <Select value={categoryId} onValueChange={onCategoryChange}>
        <SelectTrigger className="h-10 w-44">
          <SelectValue placeholder="Kategoria" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Wszystkie kategorie</SelectItem>
          {categories.map((c) => (
            <SelectItem key={c.id} value={c.id}>
              {c.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {onHidePastChange && (
        <Button
          variant="outline"
          className="h-10 gap-2"
          onClick={() => onHidePastChange(!hidePast)}
        >
          {hidePast ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          {hidePast ? "Pokaż archiwalne" : "Ukryj archiwalne"}
        </Button>
      )}
    </FilterBar>
  );
}
